<template>
    <div class="container">
       <div class="div-left">

       </div>
      <div class="div-rigth">
            <div class="image-content" style='list-style-type: none;width:auto;margin-top:auto; margin-bottom:auto;'>
          
          <div v-for="(item,index) in txtArray" :key="index">
        
                  <el-row :gutter="0" style="padding-top: 10px;">
                      <el-col :xs="16" :sm="12" :md="8" :lg="3" :xl="1" align="middle">
                          <span v-if="item.sender=='mine'">
                              <el-avatar shape="square" :src="circleUrl"></el-avatar>
                          </span>
                          <span v-else>
                              <el-avatar shape="square" :src="squareUrl"></el-avatar>
                          </span>
                      
                      </el-col>
                      <el-col :xs="8" :sm="12" :md="16" :lg="21" :xl="21">
                          <div class="bg-color-0" style="white-space: pre-line; word-break:break-all;" v-if="item.sender == 'mine'">{{ item.txt }}<el-button v-if="item.length == 'length'" @click="continueBtn">继续</el-button></div>
                          <div class="bg-color-1" style="white-space: pre-line; word-break:break-all;" v-if="item.sender == 'bot'">
                              <div v-if="item.msgArray.length >= 1">

                                    <span  v-for="(itemMsg,indexMsg) in item.msgArray" :key="indexMsg">{{itemMsg}}</span>
                                    <!--<MarkdownPro
                                    
                                    :height="400"
                                    @on-paste-image="onPasteImage"
                                    @on-ready="onReady"
                                    @on-copy="onCopy"
                                    @on-save="onSave"
                                    theme="light"
                                    v-for="(itemMsg,indexMsg) in item.msgArray" :key="indexMsg"
                                    >{{itemMsg}}</MarkdownPro>-->
                                  
                              </div>
                              <div v-else>
                                 {{ item.txt }}
                                  <!--<MarkdownPro
                                    
                                    v-model="item.txt"
                                    :height="400"
                                    @on-paste-image="onPasteImage"
                                    @on-ready="onReady"
                                    @on-copy="onCopy"
                                    @on-save="onSave"
                                    theme="light"
                                    />-->
                              </div>
                            
                          </div>
                      </el-col>
                  </el-row>

          </div>

      </div>
      <div class="image-input">
      <el-form ref="form" :model="form" label-width="180px" :rules="rules">

          <div class="image-input-rigth" style="width: 90%;">
              <el-form-item label="内容描述" prop="prompt">
                  <el-input
                      type="textarea"
                      :autosize="{ minRows: 2, maxRows: 4}"
                      placeholder="请输入内容"
                      :show-word-limit="true"
                      rows="4"
                      maxlength="1000"
                      minlength="5"
                      :clearable="true"
                      v-model="form.prompt"></el-input>
              </el-form-item>
          </div>

          <div class="image-input-left">
              <div class="image-select-size">
              <el-form-item label="内容模版" prop="apiModel">
                  <el-cascader
                      v-model="form.apiModel"
                      placeholder="试试搜索：聊天"
                      :options="options"
                      filterable @change="selectChange"></el-cascader>
              </el-form-item>
              </div>
              <div class="image-form-button">
                  <el-form-item>
                      <el-button type="primary" @click="onSubmit('form')">尝试一下</el-button>
                      <el-button type="primary" @click="resetForm('form')">重置</el-button>
                  </el-form-item>
         </div>

     </div>

 </el-form>
</div>

    </div>
      
    </div>
</template>
<script>
import { subscribe,sendMsg,disSubscribe,closeConnect } from "@/utils/mysocket";
//import { MarkdownPro } from 'vue-meditor'
import {Message} from 'element-ui';
    export default {
        name: "TxtChatGPT",
       // components: {
       //   MarkdownPro
       // },
        data(){
            return{
                circleUrl: "https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png",
                squareUrl: "https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png",
                sizeList: ["large", "medium", "small"],
                txtArray:[
                    //{sender:'mine',index:0,radom:'as',txt:'请输入',msgArray:[]},
                    //{sender:'bot',index:1,radmom:'',txt:'思考中',msgArray:[]},
                ],
                form: {
                    prompt:'',
                    apiModel:[1, 'OpenAi01'],
                    imageSize:'1',
                    index:0,
                    type:1,
                    num:5
                },
                params:{
                    type:1,
                },
                queryPage:{
                  apiModel:'',
                  pageid:1,
                  pagesize:10000
                },
                apiModelArray: [],
                options: [],
                rules: {
                  apiModel: [
                    { required: true, message: '请选择模版', trigger: 'change' }
                  ],
                  prompt: [
                    { required: true, message: '请选择输入描述内容', trigger: 'blur' }
                  ],
                }
            };
        },
        methods:{
          onPasteImage(){

          },
          userInfo(){
            let self = this;
            self.postRequest('/user/userInfo',{}).then(resp =>{
                self.userInfo = resp.data;    
                self.saveLoginInfo(resp.data);
            })
         },
          onReady(){

            },
            onCopy(){

            },
            onSave(){

            },
            continueBtn(){
              this.form.prompt='继续';
              sendMsg(this.form);
            },
            onSubmit(formParams) {
              this.$refs[formParams].validate((valid) => {
                if (valid) {
                  var minemsg = {sender:'mine',index:this.txtArray.length,radmom:'',txt:this.form.prompt,msgArray:[]};
                  this.txtArray.push(minemsg); 
                  var botmsg = {sender:'bot',index:this.txtArray.length,radmom:'',txt:'思考中...',msgArray:[]};
                  this.txtArray.push(botmsg); 
                  //console.log('submit!');
                  this.form.index = this.txtArray.length;
                  console.log('submit!:'+ this.form.index );
                  if(this.form.apiModel instanceof Array){
                    this.form.apiModel = this.form.apiModel[1];
                  }
               
                  sendMsg(this.form);
                  this.resetForm(formParams);
                  this.scrollToBottom();
                } else {
                  Message.error({message: "表单验证失败"})
                  return false;
                }
               
              });
               
            },
            imageSubscribe(msg){
                //console.log("image:"+msg);
                if(msg== null || msg == '' || msg == undefined){
                  return;
                }
                if(this.txtArray.length == 0){
                  return;
                }
                var index = msg.index;
                
                this.txtArray[index-1].msgArray.push(msg.msgArray[0]);
                this.scrollToBottom();
            },
            apiModelList(){
                let self = this;
                self.postRequest('/newGpt/apiModels',self.params).then(resp =>{
                    self.options = resp.data;
                 })
            },
            recordList(){
                let self = this;
                self.postRequest('/newGpt/list',self.queryPage).then(resp =>{
                   // self.txtArray = resp.data.rows;
                    var d = resp.data.rows;
                    for(var i in d){
                      this.scrollToBottom();
                      var txt = {sender:'mine',index:self.txtArray.length,radom:'as',txt:d[i].input,msgArray:[],length:''};
                      self.txtArray.push(txt);
                      var bottxt = {sender:'bot',index:self.txtArray.length,radom:'as',txt:d[i].result.text,msgArray:[],length:''};
                      self.txtArray.push(bottxt);
                      
                    }

                 })
            },
            resetForm(formParams){
              var mo = this.form.apiModel;
              this.$refs[formParams].resetFields();
              this.form.apiModel = mo;
            },
            selectChange(val){
              console.log(val);
              this.queryPage.apiModel = val[1];
              this.recordList();
            },
            scrollToBottom(){
              this.$nextTick(()=>{
              let box = this.$el.querySelector(".image-content")
              box.scrollTop = box.scrollHeight
              })
            }

        },
         //销毁页面之前，断开连接
      beforeDestroy: function () {
        //取消订阅
        disSubscribe();
        closeConnect();
      },
      mounted(){
        this.scrollToBottom()
      },
      update(){
        this.scrollToBottom()
      },
      created() {
      this.userInfo();
                //取消订阅
                disSubscribe();
        this.apiModelList();
        this.params.type = this.$route.query.type;
   
        var user = this.getLoginInfo();
        subscribe(this.imageSubscribe,user.email);
        if(this.form.apiModel instanceof Array){
          this.queryPage.apiModel = this.form.apiModel[1];
        }

        this.recordList();
      },
      
      destroyed() {
        //closeConnect();//离开路由之后断开websocket连接
      }
    }
</script>

<style scoped>
.bg-color-0{
    background-color: rgb(237, 247, 243);
    border-radius: 5px;
    min-height: 40px;
    height: auto;
}
.bg-color-1{
    background-color: rgb(200, 240, 224);
    border-radius: 5px;
    min-height: 40px;
    height: auto;
}
.el-col {
    border-radius: 4px;
  }
  .bg-purple-dark {
    background: #99a9bf;
  }
  .bg-purple {
    background: #d3dce6;
  }
  .bg-purple-light {
    background: #e5e9f2;
  }
  .grid-content {
    border-radius: 4px;
    min-height: 36px;
  }
.image-content{
    width: 80%;
    height: 700px;
    /**background-color: rgb(237, 247, 243); */
    border: 1px solid rgb(230, 245, 239);
    border-radius: 5px;
    overflow: auto;
 
}
.image-input{
    width: 100%;
    height: 300px;
    /**background-color: rgb(237, 247, 243); */
    border: 1px solid rgb(237, 247, 243);
    margin-top: 10px;
    border-radius: 5px;
    padding-top: 10px;
    
}
/**.container {
  display: flex;
}
.div-left{
  
  width: 10%;
  margin-right: 5px;
  background-color:  rgb(249, 249, 249);
  border-radius: 5px;
}
.div-rigth{
  
  width: 90%;
} */
</style>